import {
  CLEAR_BRANCHES,
  SET_BRANCHES,
  ADD_BRANCH,
  EDIT_BRANCH,
  DELETE_BRANCH,
} from './types';
import BranchesAPI from '../../../api/branches';

export const actions = {
  get: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await BranchesAPI.get();
      commit(CLEAR_BRANCHES);
      commit(SET_BRANCHES, data);
    } catch (error) {
      // Ignore error
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, branchInfo) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await BranchesAPI.create(branchInfo);
      commit(ADD_BRANCH, response.data);
      return response;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await BranchesAPI.update(id, updateObj);
      commit(EDIT_BRANCH, response.data);
      return response;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ commit }, branchId) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await BranchesAPI.delete(branchId);
      commit(DELETE_BRANCH, branchId);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};
